var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 148,
    viewBox: "0 0 188 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 148,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 44,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.788 59.0049C105.097 59.1074 107.049 60.7872 107.479 63.0781L108.607 69.1006C110.386 69.5065 111.714 71.0972 111.714 72.999V79.999L111.709 80.2051C111.609 82.1766 110.082 83.7713 108.14 83.9766C108.14 83.9844 108.142 83.9922 108.142 84V87.5713C108.142 88.3602 107.502 88.9999 106.713 89C105.924 89 105.284 88.3603 105.284 87.5713V83.999H82.4307V87.5713C82.4307 88.3603 81.7909 89 81.002 89C80.213 89 79.5732 88.3603 79.5732 87.5713V84C79.5732 83.9922 79.5741 83.9844 79.5742 83.9766C77.6325 83.7711 76.1049 82.1764 76.0049 80.2051L76 79.999V72.999C76.0002 71.098 77.3267 69.5073 79.1045 69.1006L80.2344 63.0781C80.6641 60.7873 82.6159 59.1076 84.9248 59.0049L85.1494 59H102.564L102.788 59.0049ZM80 70.999C78.8956 70.999 78.0002 71.8947 78 72.999V79.999C78 81.1036 78.8954 81.999 80 81.999H107.714C108.818 81.999 109.714 81.1036 109.714 79.999V72.999C109.714 71.8947 108.818 70.999 107.714 70.999H80ZM83.499 74C84.4855 74 85.2851 74.7987 85.2852 75.7852C85.2852 76.7717 84.4855 77.5713 83.499 77.5713C82.5126 77.5712 81.7139 76.7716 81.7139 75.7852C81.714 74.7988 82.5127 74.0001 83.499 74ZM104.213 74C105.199 74 105.999 74.7987 105.999 75.7852C105.999 76.7717 105.199 77.5713 104.213 77.5713C103.227 77.5711 102.428 76.7716 102.428 75.7852C102.428 74.7988 103.227 74.0002 104.213 74ZM85.1494 61C83.7059 61.0002 82.4662 62.0285 82.2002 63.4473L81.2666 68.4287H106.446L105.513 63.4473C105.247 62.0285 104.008 61.0002 102.564 61H85.1494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDefault);
export default __webpack_public_path__ + "static/media/car-default.e1cb34ef22564732b324388a639a8f29.svg";
export { ForwardRef as ReactComponent };